const map = {
	"./Aeroplanes.png": 66982,
	"./Ascott Palace.jpg": 81692,
	"./Card03.png": 47901,
	"./DesignerCollection.png": 19851,
	"./Executiv.png": 47441,
	"./Green Grocery.jpg": 84094,
	"./KX-Transport.png": 4249,
	"./Majestic-Logo.png": 10190,
	"./Musemind.jpg": 90710,
	"./Naturo.jpg": 85871,
	"./ajwah global.jpg": 90976,
	"./bangas.jpg": 46802,
	"./benazir-esita.png": 71754,
	"./blvck-group.png": 64074,
	"./customer-bg.png": 95854,
	"./flow.png": 76596,
	"./holiday-island.png": 3014,
	"./ikaigai HR.jpg": 45303,
	"./illiyeen.png": 71133,
	"./illiyeen_bg.png": 67363,
	"./item1.png": 74292,
	"./item10.png": 3822,
	"./item11.png": 3319,
	"./item2.png": 95759,
	"./item3.png": 14214,
	"./item4.png": 16633,
	"./item5.png": 10384,
	"./item6.png": 40555,
	"./item7.png": 50050,
	"./item8.png": 55077,
	"./item9.png": 19164,
	"./knitexpert.png": 85468,
	"./kx-electronics.png": 46091,
	"./kx-sourcing.png": 56934,
	"./legends.png": 57516,
	"./marketplace.png": 69971,
	"./max.png": 14088,
	"./my-generation.png": 89847,
	"./pathao.svg": 98451,
	"./svg.png": 50152,
	"./svg_old.png": 75254
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55230;